// Import React core library
import React from 'react';

const TreasuCRE = () => (
  <section 
    id="treasuCRE" 
    className="h-screen flex flex-col justify-center items-center bg-transparent md:bg-lavender p-5"
  >
    <div className="w-full aspect-video">
      <iframe
        className="w-full h-full"
        src="https://www.youtube.com/embed/0lUhvDL5Xq8"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="TreasuCRE"
      />
    </div>

    {/* mobile‑only text */}
    <p className="mt-4 px-4 text-center text-sm leading-relaxed text-gray-800 block md:hidden">
      <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-ubuntu text-electricViolet mb-4">
        Our TreasuCRE Bundled Services
      </h1>
      <p
        className="text-lg md:text-2xl lg:text-3xl font-light font-merriweather text-deepIndigo"
        style={{ lineHeight: '1.5' }}
      >
        We offer you a streamlined approach to managing liquidity, debt, solvency, and capital – all from one easy-to-use platform. Get comprehensive insights for financial clarity and tools to stay financially on track.
      </p>
    </p>
  </section>
);

export default TreasuCRE;
